export const isStandalone = (win = window) =>
  Boolean(
    win.navigator?.standalone === true ||
    win.matchMedia?.("(display-mode: standalone)").matches ||
    win.matchMedia?.("(display-mode: minimal-ui)").matches,
  );

// iPadOS reports itself as "Macintosh", but has touch.
export const isIos = (nav = window.navigator) =>
  /iphone|ipad|ipod/i.test(nav.userAgent || "") ||
  (/macintosh/i.test(nav.userAgent || "") && nav.maxTouchPoints > 1);

export const installMethod = ({ standalone, ios, canPrompt }) => {
  if (standalone) return null;
  if (ios) return "ios";
  if (canPrompt) return "prompt";
  return null;
};

export const shouldOfferInstallHint = ({
  method,
  startedWithoutGroups,
  hasParticipants,
  alreadyShown,
}) =>
  Boolean(method && startedWithoutGroups && hasParticipants && !alreadyShown);
